import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  container: {
    height: theme.spacing(3),
    userSelect: 'none',
    zIndex: 2,
    flexShrink: 0,
    borderRadius: theme.spacing(0.25),
    borderTop: `2px dashed ${theme.palette.grey[700]}`,
    borderBottom: `2px dashed ${theme.palette.grey[700]}`
  },
  root: {
    position: 'absolute',
    height: theme.spacing(2.5),
    transition: theme.transitions.create('box-shadow', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.short
    })
  },
  overlay: {
    margin: 0,
    zIndex: 0,
    position: 'absolute',
    '&:hover': {
      backgroundColor: `rgba(0, 0, 0, 0.04)`,
      cursor: 'pointer'
    }
  },
  resizeHandle: {
    top: 0,
    left: 0,
    position: 'absolute',
    height: ({ quantity }) =>
      `${quantity * theme.spacing(3) + (quantity - 1) * theme.spacing(0.5)}px `,
    zIndex: 4,
    cursor: 'ew-resize',
    opacity: 0,
    overflow: 'hidden',
    transition: theme.transitions.create(['opacity'], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.shortest
    })
  },
  resizeIcon: {
    top: theme.spacing(0.25),
    marginTop: ({ quantity }) =>
      `${(quantity * theme.spacing(3) + (quantity - 1) * theme.spacing(0.5)) *
        0.5 -
        12}px`
  },
  resizeHandleStart: {
    left: theme.spacing(-0.5)
  },
  resizeHandleEnd: {
    left: `calc(100% - ${theme.spacing(2.5)}px)`
  },
  periodBlock: {
    backgroundColor: theme.palette.common.white
  },
  zIndexOverlayContainer: {
    zIndex: 15
  },
  cursorChange: {
    cursor: 'pointer'
  },
  toBeHired: {
    backgroundColor: theme.palette.resourceRequest.toBeHired.main
  },
  rejected: {
    backgroundColor: theme.palette.resourceRequest.requestRejected.main
  },
  leftBorder: {
    borderLeft: `2px dashed ${theme.palette.grey[700]}`
  },
  rightBorder: {
    borderRight: `2px dashed ${theme.palette.grey[700]}`
  },
  resizeContainer: {
    zIndex: 50,
    position: 'absolute',
    top: 0,
    width: theme.spacing(2.5),
    height: ({ quantity }) =>
      `${quantity * theme.spacing(3) + (quantity - 1) * theme.spacing(0.5)}px `,
    '&:hover $resizeHandle': {
      opacity: 1
    },
    '&:hover': {
      backgroundColor: theme.palette.common.white,
      opacity: 0.8
    }
  },
  zIndex: {
    zIndex: 16
  }
}));

export default useStyles;
